import React, { Component } from 'react';
import xtend from 'xtend';
import _ from 'underscore';
import { Map } from 'immutable'

import V from './validators/'

export default function ValidatorHoc (WrappedComponent) {

    function valuesAreValid (validators, data, event) {
        let invalids = [];

        Object.keys(data).map(key => {
            const value = data[key];
            
            // If there are validators for this key
            if (validators[key]) {

                // Iterate through all available validator funcs
                validators[key].validators
                    .map(test => {

                        // if test returns false, then it failed
                        if (!test(value, data, event)) {
                            invalids.push({
                                group: validators[key].group,
                                validators: validators[key].validators,
                                description: validators[key].description,
                                key: key
                            })
                        }
                    });
            }
        }, this);

        return invalids;
    }

    function containsRequired (validators, data) {
        let missing = [];
        Object.keys(validators).map(function (key) {
            if (
                (
                    validators[key].required === true ||
                    (
                        typeof validators[key].required === 'function' &&
                        validators[key].required(data) === true
                    )
                ) &&
                (
                    data.hasOwnProperty(key) === false ||
                    data[key] === null
                )
            ) {
                missing.push({
                    key: key,
                    group: validators[key].group,
                    validators: validators[key].validators,
                    description: validators[key].description
                });
                
            }
        }, this);
        return missing;
    }

    function Validator (mode, data) {
        let missing = containsRequired(V[mode], data);
        let invalids = valuesAreValid(
            V[mode],
            data,
            Map.isMap(this.props.event) ?
                this.props.event.toJS() : this.props.event
        );

        return (invalids.length || missing.length) ?
            _.uniq(Array.prototype.concat.apply(invalids, missing)) :
            true;
    }

    return class extends Component {
        constructor (props) {
            super(props);
            this.validate = Validator.bind(this);
        }

        render () {
            return React.createElement(
                WrappedComponent,
                xtend({
                    validate: this.validate
                }, this.props),
                this.props.children || []
            );
        }
    };
}
